// @flow

export const transformSimilarItemsFromV3 = (similarItems: any[]) =>
    similarItems.map<any>((algoliaItem: any) => transformSimilarItemFromV3(algoliaItem));
const transformSimilarItemFromV3 = (algoliaItem: any) => {
    const transformed = {
        biddingInfo: {},
        buyNow: { price: algoliaItem.buyNowPrice, status: algoliaItem.buyNowStatus },
        catalog: {
            buyersPremium: {},
            catalogId: algoliaItem.catalog.id,
            catalogStatus: algoliaItem.catalog.status,
            currency: algoliaItem.currency,
            hasVideo: false,
            isCatalogOnly: algoliaItem.auctionType === 'catalogOnly',
            saleStartTs: algoliaItem.saleStartTs,
            title: algoliaItem.catalog.title,
        },
        catalogRegistration: {},
        item: {
            catalogId: algoliaItem.catalog.id,
            highBidEstimate: algoliaItem.highBidEstimate,
            imageVersion: algoliaItem.imageVersion,
            index: 9999,
            isSEOExcluded: algoliaItem.SEOExcluded,
            itemId: algoliaItem.itemId,
            lotNumber: algoliaItem.lotNumber,
            lowBidEstimate: algoliaItem.lowBidEstimate,
            photos: algoliaItem.photos,
            sellerId: algoliaItem.house.id,
            startPrice: algoliaItem.currentBid,
            title: algoliaItem.title,
        },
        itemId: algoliaItem.itemId,
        liveItemStatus: {},
        promoted: Boolean(algoliaItem.promoted),
        seller: { name: algoliaItem.house.name, sellerId: algoliaItem.house.id },
        version: '20191113', // version of this model
    };
    return transformed;
};
